import { render, staticRenderFns } from "./skt.vue?vue&type=template&id=f58d4b80&"
import script from "./skt.vue?vue&type=script&lang=js&"
export * from "./skt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports